export default __webpack_public_path__ + "static/media/highknee_trac_thumb.1b24c65d.png";